import { useQuery } from "@tanstack/react-query"
import { CanonicalTopicsQuery } from "../lib/canonicalTopicsQuery"

export function useCanonicalTopicsQuery(...args: Parameters<typeof CanonicalTopicsQuery>) {
  return useQuery(CanonicalTopicsQuery(...args))
}
